module.exports = __webpack_public_path__ + "static/media/Sketch4.3daec0cb.jpeg";